<p-dialog #globalDialog
          appendTo="body"
          [visible]="(visible$ | async) ?? false"
          [header]="gDS.title"
          [modal]="false"
          [closable]="false"
          [dismissableMask]="false"
          styleClass="global-status-dialog"
          [style]="{ width: '450px' }"
          [baseZIndex]="10000"
          (onHide)="close()">
  <div class="flex flex-col items-center text-center p-2 space-y-2 text-surface-900 dark:text-surface-100">
    <i *ngIf="gDS.type !== DialogType.Loading" class="text-3xl text-red-500 bi bi-exclamation-triangle-fill"></i>
    <span class="text-xl text-surface-900 dark:text-surface-100">{{ gDS.message }}</span>
    <h3 *ngIf="gDS.type !== DialogType.Loading" class="text-red-600 dark:text-red-400">{{ gDS.details }}</h3>
    <div class="flex flex-col items-center text-center p-2">
      <p-progressSpinner *ngIf="gDS.type === DialogType.Loading" styleClass="w-6rem h-6rem" />
    </div>
    <div class="mt-2 flex flex-row gap-2 justify-center" *ngIf="gDS.type !== DialogType.Loading">
      <button pButton label="Close" class="p-button-danger" (click)="close()"></button>
    </div>
  </div>
</p-dialog>
